// extracted by mini-css-extract-plugin
export default {"container_CTA":"CtaSection_container_CTA__GY4kL","btn_CTA":"CtaSection_btn_CTA__SB5Mb"};